module.exports = __webpack_public_path__ + "images/icon-top-freight---7560cdefb2914f8a5ddcd11e7f7b3930.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/views/app/images/icon-top-freight.png
// module id = 387
// module chunks = 0